module.exports = __webpack_public_path__ + "static/media/includeIcon.fcd7e32f.svg";